import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataPatientDetail.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataPatientDetail.error;
export const dataProgressBarResponse = (state: RootState) =>
  state.dataProgressBar.dataProgressBarResponse;
